import React, { useState, useEffect } from "react";
import {
    Avatar,
    Box,
    Button,
    Grid2,
    MenuItem,
    InputLabel,
    FormControl,
    Select,
    FormHelperText,
    FormControlLabel,
    Checkbox,
    Grid,
    Modal,
    Fade,
    IconButton,
    Typography,
} from "@mui/material";
import Header from "../Header/Header";
import TextField from "@mui/material/TextField";
import consts from "../../constant";
import Axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import toast, { Toaster } from "react-hot-toast";
import { useForm, Controller } from "react-hook-form";
import "./Staking.css";
import { ToastContainer } from "react-toastify";
import CloseIcon from '@mui/icons-material/Close';

const drawerWidth = 260;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

const CreateBanner = () => {
    const token = localStorage.getItem("adminToken");
    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const back = useNavigate();







    const [selectedDurations, setSelectedDurations] = useState(["3", "6", "9", "12"]);


    const [amount, setAmount] = useState(""); // User-entered amount
    const [twentyPercent, setTwentyPercent] = useState(""); // 20% of amount
    const [tjrmPrice, setTjrmPrice] = useState(""); // TJRM current price
    const [tokenWorth, setTokenWorth] = useState(""); // Token worth




    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);




    const {
        register,
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm();

    const [datahhhhhh, setDatahhhhhh] = useState();

    const onSubmit = async (data) => {
        console.log(data, "gvghcsv");
        try {


            const payload = {
                planName: data.planName,
                description: data.description,
                startTime: data.startTime,
                endTime: data.endTime,
                commission: parseInt(data.commission)
            }


            const response = await Axios.post(
                `${consts.BackendUrl}/admin/stakingplan`,
                payload,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "Content-Type, Authorization",
                        "Access-Control-Allow-Credentials": "true",
                        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                        Authorization: localStorage.getItem("adminToken"),
                    },
                }
            );

            const { data: responseData } = response;

            if (responseData?.success) {
                toast.success(responseData?.message || "Operation successful!");
                setTimeout(() => {
                    back(`/${consts.route}/stakingBanner`);
                }, 1000);
            } else {
                toast.error(responseData?.message || "An unexpected error occurred.");
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong!";
            toast.error(errorMessage);
            console.error(error, "Error creating pair");
        }
    };


    const handleUpdate = async () => {


    }



    return (
        <div className="UserList create-asset">
            <ToastContainer />
            <Box sx={{ display: lg ? "flex" : "block" }}>
                <Header />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 5,
                        width: { lg: `calc(100% - ${drawerWidth}px)` },
                        marginTop: "50px",
                    }}
                >
                    <form onSubmit={handleSubmit(onSubmit)}>

                        <Grid2 container spacing={2}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <div className="d-flex align-fe">
                                    <Button
                                        className="Backbutton"
                                        variant="contained"
                                        onClick={() => {
                                            back(`/${consts.route}/stakingBanner`);
                                        }}
                                    >
                                        Back
                                    </Button>
                                </div>

                                <div className="custom_table p-10">
                                    <Grid2
                                        container
                                        spacing={0}
                                        style={{ height: "100%" }}
                                        alignItems={"center"}
                                    >
                                        <Grid2
                                            item
                                            size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                                            sx={{
                                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                    color: "white",
                                                },
                                            }}
                                        >
                                            {/*  plan name */}
                                            <div className="view-inp p-10">
                                                <div className="txt-white">Plan Name</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                        {...register("planName", { required: "Plan Name is required" })}
                                                        error={!!errors.planName}
                                                    />
                                                    <p style={{ color: "red" }} className="err">{errors?.planName?.message}</p>
                                                </div>
                                            </div>

                                            {/*  plane description */}
                                            <div className="view-inp p-10">
                                                <div className="txt-white">Plan Description</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                        {...register("description", { required: "Description is required" })}
                                                        error={!!errors.description}
                                                        multiline
                                                        rows={4}
                                                    />
                                                    <p style={{ color: "red" }} className="err">{errors?.description?.message}</p>
                                                </div>
                                            </div>
                                            {/*  Start date */}

                                            <div className="view-inp p-10">
                                                <div className="txt-white">Start Date</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        type="date"
                                                        fullWidth
                                                        {...register("startTime", { required: "Start Time is required" })}
                                                        error={!!errors.startTime}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    <p style={{ color: "red" }} className="err">{errors?.planName?.message}</p>
                                                </div>
                                            </div>
                                            {/*  end date */}
                                            <div className="view-inp p-10">
                                                <div className="txt-white">End Date</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        type="date"
                                                        fullWidth
                                                        {...register("endTime", { required: "end Time is required" })}
                                                        error={!!errors.endTime}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    <p style={{ color: "red" }} className="err">{errors?.endTime?.message}</p>
                                                </div>
                                            </div>

                                            <div className="view-inp p-10">
                                                <div className="txt-white">Commision %</div>
                                                <div className="mt-10">
                                                    <TextField
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        type="number"
                                                        fullWidth
                                                        {...register("commission", { required: "Commission is required" })}
                                                        error={!!errors.commission}
                                                    />
                                                    <p style={{ color: "red" }} className="err">{errors?.commission?.message}</p>
                                                </div>
                                            </div>

                                        </Grid2>

                                    </Grid2>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{ margin: "20px 10px", padding: "8px 40px" }}
                                    >
                                        Create Banner
                                    </Button>

                                </div>
                            </Grid2>
                        </Grid2>
                    </form>
                </Box>

            </Box >
            <Toaster />



        </div >
    );
};

export default CreateBanner;
